/**
 * Created by Ivan on 23.04.2023
 */

const PrizeBarComponent = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.options = options || {};
        this.reward = this.options.reward;
        this.canClick = this.options.canClick !== undefined ? this.options.canClick : true;

        this.addProgressBar();
        this.addPrize();

        this.setAnchorPoint(0.5, 0.5);
        cleverapps.UI.wrap(this);

        this.state = PrizeBarComponent.STATE_ACTIVE;
    },

    updateProgress: function (progress, goal, options) {
        this.progressBar.setGoal(goal);
        if (progress >= goal) {
            options = options || {};
            const callback = options.callback;

            options.callback = function () {
                this.setFull();
                if (callback) {
                    callback();
                }
            }.bind(this);
        }
        this.progressBar.setPercentage(progress, options);
    },

    setPercentage: function (percentage, options) {
        this.progressBar.setPercentage(percentage, options);
    },

    addProgressBar: function () {
        const styles = cleverapps.styles.PrizeBarComponent.progressBar;
        const options = this.options.progressBar || {};

        const progressBar = this.progressBar = new ScaledProgressBar({
            progress: options.progressImage || bundles.progress_bar.frames.bar_green,
            background: options.progressBgImage || bundles.progress_bar.frames.bg_green,
            barText: options.removeBarText ? undefined : ({
                font: cleverapps.styles.FONTS.PRIZE_BAR_TEXT,
                dy: styles.barText.dy,
                ...options.barText 
            }),
            height: options.height,
            progressFrames: options.progressFrames
        });
        progressBar.setLength(options.width || styles.length);
        progressBar.setAlignment(progressBar.width / 2, progressBar.height / 2);

        this.addChild(progressBar);
    },

    addPrize: function () {
        if (this.prize || this.options.prize === false) {
            return;
        }

        const prize = this.prize = new cleverapps.Spine(this.options.prize || bundles.prize.jsons.prize_json);
        prize.setAnimation(0, "idle", true);

        if (this.options.fitPrizeToBarHeight) {
            cleverapps.UI.fitToBox(prize, {
                width: prize.width,
                height: this.progressBar.height
            });
        }

        cleverapps.tooltipManager.create(prize, {
            text: this.options.tooltipText || Messages.get("Reward"),
            rewards: this.reward,
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            size: cleverapps.styles.UI.Tooltip.SIZE.short
        });
        prize.setAlignment(this.options.prizePosition || cleverapps.styles.PrizeBarComponent.prize);
        this.progressBar.addChild(prize);
        prize.replaceParentSamePlace(this);
    },

    setTooltipEnabled: function (enabled) {
        if (this.prize && this.prize.tooltipHandler) {
            this.prize.tooltipHandler.setEnabled(enabled);
        }
    },

    showTooltip: function () {
        if (this.prize && this.prize.tooltipHandler) {
            this.prize.tooltipHandler.onClick();
        }
    },

    setFull: function () {
        if (!this.prize || this.state === PrizeBarComponent.STATE_COLLECTED) {
            return;
        }
        this.state = PrizeBarComponent.STATE_FULL;

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                cleverapps.tooltipManager.remove(this.prize);
                cleverapps.effects.fire("ui.prize_bar.created");

                this.addLighting();
                this.addShine();
                this.prize.setAnimation(0, "animation", true);

                if (this.canClick) {
                    this.addFinger();
                    cleverapps.UI.applyHover(this.prize);
                    cleverapps.UI.onClick(this.prize, this.onClick.bind(this));
                }
            })
        ));
    },

    onClick: function () {
        this.animateCollected();
    },

    animateCollected: function () {
        this.stopAllActions();
        this.prize.runAction(new cc.Sequence(
            StandartAnimations.disappear(this.prize),
            new cc.CallFunc(() => {
                this.setCollected();
            })
        ));
    },

    setCollected: function () {
        this.state = PrizeBarComponent.STATE_COLLECTED;
        this.removeLighting();
        this.removePrize();
        this.addMark();
        this.options.onCollect && this.options.onCollect();
    },

    setActive: function () {
        this.state = PrizeBarComponent.STATE_ACTIVE;
        this.mark && this.mark.removeFromParent();
        this.addPrize();
    },

    addMark: function () {
        if (this.options.noMark) {
            return;
        }
        const mark = this.mark = new cc.Sprite(bundles.prize.frames.mark_png);
        this.addChild(mark);
        mark.setAlignment(this.options.markPosition || cleverapps.styles.PrizeBarComponent.mark);
    },

    addLighting: function () {
        const lightning = this.lightning = new cleverapps.Spine(bundles.progress_bar.jsons.flash_json);
        lightning.setAnimation(0, "animation");
        this.progressBar.addChild(lightning);

        lightning.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.CallFunc(() => {
                    lightning.setVisible(true);
                    lightning.setAlignment(lightning.width / 2, this.progressBar.height / 2);
                    lightning.setAnimation(0, "animation");
                }),
                new cc.MoveTo(0.4, this.progressBar.width + this.prize.width / 2 - lightning.width / 2, this.progressBar.height / 2),
                new cc.CallFunc(() => {
                    lightning.setVisible(false);
                }),
                new cc.DelayTime(2)
            )
        ));

        return lightning;
    },

    removeLighting: function () {
        if (this.lightning) {
            this.lightning.removeFromParent();
            delete this.lightning;
        }
    },

    removePrize: function () {
        if (this.prize) {
            this.stopAllActions();
            this.prize.removeFromParent();
            delete this.prize;
        }
    },

    addFinger: function () {
        const styles = cleverapps.styles.PrizeBarComponent.prize;
        FingerView.hintTap(this.prize, {
            delay: 1.6,
            scale: styles.finger.scale
        });
    },

    addShine: function () {
        const shining = this.shine = StandartAnimations.rays(this.prize, { skin: "white" });
        shining.setTimeScale(2);
    },

    showUp: function (callback, delay) {
        this.progressBar.barText.setScale(0);
        delay = delay || 0.2;

        this.progressBar.barText.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut())
        ));

        this.prize.setScale(0);
        this.prize.runAction(new cc.Sequence(
            new cc.ScaleTo(0, 0),
            new cc.Show(),
            new cc.DelayTime(delay),
            new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut()),
            new cc.CallFunc(callback || (() => {}))
        ));
    },

    receivePrize: function () {
        Object.keys(this.reward).forEach((type) => {
            const reward = new Reward(type, this.reward[type], { event: this.options.rewardEvent || cleverapps.EVENTS.EARN.OTHER });
            reward.receiveReward();
            reward.collectRewardsAnimation(this.prize, {
                flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
                spawnHaptic: "reward.spawn",
                landHaptic: "reward.land",
                collectHaptic: "reward.collect"
            });
        });
    }
});

PrizeBarComponent.STATE_ACTIVE = 0;
PrizeBarComponent.STATE_FULL = 1;
PrizeBarComponent.STATE_COLLECTED = 2;

cleverapps.styles.PrizeBarComponent = {
    progressBar: {
        length: 400,
        barText: {
            dy: 1
        }
    },
    prize: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 0 },

        flyY: 10,

        finger: {
            scale: 0.6
        }
    },
    mark: {
        x: { align: "right", dx: 80 },
        y: { align: "center", dy: 0 }
    }
};
